import { SagaIterator } from 'redux-saga';
import { fork, takeEvery, takeLatest } from 'redux-saga/effects';

import { rootDataAccelerationSaga } from '~src/dataAcceleration/sagas/DataAccelerationSaga';
import { rootPublishedConnectionSaga } from '~src/publishedConnection/sagas/PublishedConnectionSaga';
import { rootResourceGovernanceSaga } from '~src/schedule/sagas/ResourceGovernanceSagas';

import { rootBackgroundJobSaga } from '../../../backgroundJob/sagas/BackgroundJobSagas';
import { rootDisableWorkbookAccelerationActionSaga } from '../../../dataAcceleration/sagas/DisableWorkbookAccelerationSaga';
import { rootEnableWorkbookAccelerationActionSaga } from '../../../dataAcceleration/sagas/EnableWorkbookAccelerationSaga';
import { rootMetricSaga } from '../../../metrics/sagas/MetricSagas';
import { rootMetricSpaceSagas } from '../../../metrics/sagas/MetricsSpaceSaga';
import { rootWorkbookSaga } from '../../../workbook/sagas/WorkbookSagas';
import {
  ChangeExtractDsToLive,
  EditConnections,
  GroupDatabases,
  RemoveExternalContentAction,
  SetCertification,
  SetContact,
  SetDataQuality,
  SetDataQualityTrigger,
  SetDescription,
  UngroupDatabases,
  UpdateNlpSetting,
} from '../../actions/AppActionTypes';
import { handleEditDataConnectionAction } from './connectivity/EditConnectionSaga';
import { rootCollectionSaga } from './content/collections/CollectionSagas';
import { rootContentDetailDialogSaga } from './content/ContentDetailDialogSaga';
import { handleGroupDatabases } from './content/GroupDatabasesSaga';
import { handleRemoveExternalContent } from './content/RemoveExternalContentSaga';
import { rootContentSaga } from './content/RootContentSaga';
import { handleSetCertification } from './content/SetCertificationSaga';
import { handleSetContact } from './content/SetContactSaga';
import { handleSetDataQuality } from './content/SetDataQualitySaga';
import { handleSetDataQualityTrigger } from './content/SetDataQualityTriggerSaga';
import { handleSetDescription } from './content/SetDescriptionSaga';
import { handleUngroupDatabases } from './content/UngroupDatabasesSaga';
import { rootContentCreationSaga } from './ContentCreationSagas';
import { rootContentSelectionSaga } from './ContentSelectionSagas';
import { rootAccelerationTaskMenuActionSaga } from './dataAcceleration/DataAccelerationTaskMenuSaga';
import { rootDataAlertMenuActionSaga } from './DataAlertMenuSagas';
import { handleChangeExtractDsToLiveAction } from './extractTasks/ChangeExtractDsToLiveSaga';
import { rootExtractRefreshSaga } from './extractTasks/RootExtractRefreshSaga';
import { rootGroupMenuActionSaga } from './GroupMenuSagas';
import { rootRunFlowTaskMenuActionSaga } from './RunFlowTaskMenuSaga';
import { rootScheduleMenuActionSaga } from './ScheduleMenuSagas';
import { rootServerUserMenuActionSaga } from './ServerUserMenuSagas';
import { rootSiteMenuActionSaga } from './SiteMenuActionSagas';
import { rootSiteUserMenuActionSaga } from './SiteUserMenuSagas';
import { handleUpdateNlpSetting } from './UpdateNlpSettingSagas';

export function* rootSpacesSaga(): SagaIterator {
  yield fork(rootAccelerationTaskMenuActionSaga);
  yield fork(rootContentCreationSaga);
  yield fork(rootContentSaga);
  yield fork(rootContentSelectionSaga);
  yield fork(rootCollectionSaga);
  yield fork(rootContentDetailDialogSaga);
  yield fork(rootDataAccelerationSaga);
  yield fork(rootDisableWorkbookAccelerationActionSaga);
  yield fork(rootEnableWorkbookAccelerationActionSaga);
  yield fork(rootExtractRefreshSaga);
  yield fork(rootWorkbookSaga);
  yield fork(rootMetricSaga);
  yield fork(rootMetricSpaceSagas);
  yield fork(rootBackgroundJobSaga);
  yield fork(rootDataAlertMenuActionSaga);
  yield fork(rootRunFlowTaskMenuActionSaga);
  yield fork(rootScheduleMenuActionSaga);
  yield fork(rootSiteMenuActionSaga);
  yield fork(rootSiteUserMenuActionSaga);
  yield fork(rootServerUserMenuActionSaga);
  yield fork(rootGroupMenuActionSaga);
  yield fork(rootPublishedConnectionSaga);
  yield fork(rootResourceGovernanceSaga);
  yield takeLatest(SetDataQuality, handleSetDataQuality);
  yield takeLatest(SetDataQualityTrigger, handleSetDataQualityTrigger);
  yield takeLatest(SetDescription, handleSetDescription);
  yield takeLatest(SetCertification, handleSetCertification);
  yield takeLatest(GroupDatabases, handleGroupDatabases);
  yield takeLatest(UngroupDatabases, handleUngroupDatabases);
  yield takeLatest(UpdateNlpSetting, handleUpdateNlpSetting);
  yield takeLatest(SetContact, handleSetContact);
  yield takeLatest(RemoveExternalContentAction, handleRemoveExternalContent);
  yield takeEvery(EditConnections, handleEditDataConnectionAction);
  yield takeEvery(ChangeExtractDsToLive, handleChangeExtractDsToLiveAction);
}
